
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subjects/[slug]",
      function () {
        return require("private-next-pages/subjects/[slug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subjects/[slug]"])
      });
    }
  